import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SproutUIThemeProvider } from "sprout-ui-theme";
import { NavigationListProvider } from "@sprout/list-navigation";
import { ErrorBoundary } from "@sprout/views";
import AppQuery from "./App_Query";
import GlobalStyles from "./GlobalStyles";
const App = ()=>{
    return /*#__PURE__*/ _jsxs(SproutUIThemeProvider, {
        children: [
            /*#__PURE__*/ _jsx(GlobalStyles, {}),
            /*#__PURE__*/ _jsx(ErrorBoundary, {
                children: /*#__PURE__*/ _jsx(NavigationListProvider, {
                    children: /*#__PURE__*/ _jsx(AppQuery, {})
                })
            })
        ]
    });
};
export default App;
